import { Address } from 'src/api';

const utcOptions: Intl.DateTimeFormatOptions = { timeZone: 'UTC' };

export function localeDate(date: string | undefined): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString(undefined, utcOptions);
}

export function longDate(date: string | undefined): string {
    if (!date) return '';
    const dateTime = new Date(date);
    const monthNames = [
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC',
    ];
    const monthNumber = dateTime.getUTCMonth();
    const month = monthNames[monthNumber];
    const dateOfMonth = dateTime.getUTCDate();
    const year = dateTime.getUTCFullYear();

    return `${month}\xa0${dateOfMonth}\n${year}`;
}

export function currency(num: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(num);
}

export function address(address: Address | undefined, isWrap?: boolean): string {
    if (!address) {
        return 'Unknown Address';
    }
    if (isWrap) {
        return `${address.streetAddress}${address.unit ? (' #' + address.unit) : ''}<br/>${address.city}, ${address.state} ${address.zip}`;
    }
    return `${address.streetAddress}${address.unit ? (' #' + address.unit) : ''}, ${address.city}, ${address.state} ${address.zip}`;
}

export function addressNoZip(address: Address | undefined): string {
    if (!address) {
        return 'Unknown Address';
    }
    if (address.unit) {
        return `${address.streetAddress} #${address.unit}, ${address.city}, ${address.state}`;
    }
    return `${address.streetAddress}, ${address.city}, ${address.state}`;
}

export const twoDigitsAmount = (amount: string) => {
    let value: string = amount.replace(/[^\d.]/gi, '');
    if (value.length === 0) {
        return value;
    }
    value = value.replace(/^0+/g, '');
    if (value.length === 0) {
        return '0';
    }
    if (value.startsWith('.')) {
        value = `0${value}`;
    }
    const numbers = value.split('.');
    if (numbers.length > 1) {
        return `${numbers[0]}.${numbers[1].slice(0, 2)}`;
    }
    return value;
};

export const getDurationBillingString = (duration?: number, billingFrequency?: number) => {
    let result = '';
    if (duration === 1) {
        result = '1 month';
    } else if (duration) {
        result = `${duration} months`;
    } else {
        result = 'Ongoing';
    }
    return `${result} - ${getBillingFrequencyString(billingFrequency)}`;
};

export const getBillingFrequencyString = (freq: number | undefined) => {
    switch (freq) {
        case 0:
            return 'One Time';
        case 1:
            return 'Monthly';
        case 2:
            return 'Every other month';
        case 3:
            return 'Quarterly';
        case 6:
            return 'Bi-Annual';
        case 12:
            return 'Annual';
        default:
            return 'Unknown';
    }
};

export const toNumber = (value: string) => value.replace(/[^\d]/gi, '');
